import { useCallback, useRef } from 'react';

/** Copies each column's header text into its body cells as `data-label` (the card list's labels, spec 6.12). */
function labelCells(table: HTMLTableElement) {
  const heads = Array.from(table.tHead?.rows[0]?.cells ?? []).map((cell) => cell.textContent?.trim() ?? '');
  for (const body of Array.from(table.tBodies)) {
    for (const row of Array.from(body.rows)) {
      Array.from(row.cells).forEach((cell, i) => {
        const text = heads[i];
        if (text && cell.dataset.label !== text) cell.dataset.label = text;
        else if (!text && cell.dataset.label !== undefined) delete cell.dataset.label;
      });
    }
  }
}

/**
 * A callback ref for a list table that becomes a card list below 768 px (class `table-cards`): it labels the
 * cells with their column names and keeps them labelled while rows change.
 */
export function useCardTable() {
  const observer = useRef<MutationObserver | null>(null);
  return useCallback((table: HTMLTableElement | null) => {
    observer.current?.disconnect();
    observer.current = null;
    if (!table) return;
    labelCells(table);
    if (typeof MutationObserver === 'undefined') return;
    observer.current = new MutationObserver(() => labelCells(table));
    observer.current.observe(table, { childList: true, subtree: true, characterData: true });
  }, []);
}
